const initPlayer = (options = {}) => {
    console.log("options.url:",options.url)
    let defaultOptions = {
        videoId: options.videoId,
        m3u8: options.url,
        flv:options.url,
        autoplay: true,
        live: true,
        controls: options.controls,
        controlbar: { playToggle: false },
        bigPlayButton: false,
        'coverpic': {'style': 'default', 'src': options.coverpic},
        poster: { style: "cover", src: options.pimg },
        wording: {
            1: "网络错误，请检查网络配置或者播放链接是否正确",
            2: "网络错误，请检查网络配置或者播放链接是否正确",
            3: "视频解码错误",
            4: "当前系统环境不支持播放该视频格式",
            5: "当前系统环境不支持播放该视频格式",
            12: "请填写视频播放地址",
            13: "直播已结束，请稍后再来",
            2032: "请求视频失败，请检查网络",
            2048: "请求视频文件失败，可能是网络错误或者跨域问题",
        },
        width: options.width,
        height: options.height,
        listener: function(msg) {
            options.listener && options.listener(msg);
        },
    };
    return options.videoId ? new TcPlayer(defaultOptions.videoId, defaultOptions): false;
};

export default initPlayer;
